'use strict';

var Element = require('./core.element');

var exports = module.exports = Element.extend({
  chart: null,
  // the animation associated chart instance
  currentStep: 0,
  // the current animation step
  numSteps: 60,
  // default number of steps
  easing: '',
  // the easing to use for this animation
  render: null,
  // render function used by the animation service
  onAnimationProgress: null,
  // user specified callback to fire on each step of the animation
  onAnimationComplete: null // user specified callback to fire when the animation finishes

}); // DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */

Object.defineProperty(exports.prototype, 'animationObject', {
  get: function get() {
    return this;
  }
});
/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */

Object.defineProperty(exports.prototype, 'chartInstance', {
  get: function get() {
    return this.chart;
  },
  set: function set(value) {
    this.chart = value;
  }
});